import React, { Component } from 'react'
import { Route, BrowserRouter as Router } from 'react-router-dom'
import { compose, withState } from 'recompose'
import Do from './containers/DoContainer'
import Home from './pages/Home'
import Make from './containers/MakeContainer'
import Pick from './containers/PickContainer'
import PlayLogVideo from './containers/PlayLogVideoContainer'
import PropTypes from 'prop-types'
import _ from 'lodash'
import database from 'firebase/database'
import leftPad from 'left-pad'
import rightPad from 'right-pad'

// https://stackoverflow.com/a/11509718
function onlyProp(obj) {
	if (!obj) {
		return null
	}
	const keys = Object.keys(obj)
	return obj[keys[0]]
}

class AppLoggedIn extends Component {
	componentDidMount() {
		if (!this.props.user) {
			return
		}
		const oneHour = 1000 * 60 * 60
		const when = String(new Date().getTime() - oneHour)
		const userOneHourAgo = `${rightPad(this.props.user.uid, 100, '.')}${leftPad(
			when,
			15,
			'0'
		)}`
		const userForverFromNow = `${rightPad(this.props.user.uid, 100, '.')}${_.repeat(
			'9',
			15
		)}`
		this.recentLogRef = database()
			.ref(`logs`)
			.orderByChild('userWhen')
			.startAt(userOneHourAgo)
			.endAt(userForverFromNow)
			.limitToLast(1)
		this.recentLogRef.on('value', recentLogSnap => {
			const recentLogValue = onlyProp(recentLogSnap.val())
			this.props.setRecentLog(recentLogValue)
			this.props.setRecentExercise()
			if (recentLogValue) {
				this.recentExerciseRef = database()
					.ref('exercises')
					.orderByKey()
					.equalTo(recentLogValue.exercise)
				this.recentExerciseRef.on('value', recentExerciseSnap => {
					this.props.setRecentExercise(onlyProp(recentExerciseSnap.val()))
				})
			}
		})
	}
	componentWillUnmount() {
		this.recentLogRef.off()
		if (this.recentExerciseRef) {
			this.recentExerciseRef.off()
		}
	}

	render() {
		return (
			<Router>
				<div>
					<Route exact path="/" render={() => <Home user={this.props.user} />} />
					<Route
						exact
						path="/pick"
						render={() =>
							<Pick
								recentExercise={this.props.recentExercise}
								recentLog={this.props.recentLog}
							/>}
					/>
					<Route
						exact
						path="/do/:exerciseId"
						render={() =>
							<Do
								tab={this.props.doTab}
								setTab={this.props.setDoTab}
								uid={this.props.user.uid}
							/>}
					/>
					<Route exact path="/make/:title" render={() => <Make />} />
					<Route
						exact
						path="/playLogVideo/:logId/:backTo/:backTitle"
						render={() => <PlayLogVideo uid={this.props.user.uid} />}
					/>
				</div>
			</Router>
		)
	}
}
AppLoggedIn.propTypes = {
	user: PropTypes.object.isRequired,
	setRecentLog: PropTypes.func.isRequired,
	setRecentExercise: PropTypes.func.isRequired,
	recentExercise: PropTypes.object,
	recentLog: PropTypes.object,
	doTab: PropTypes.string.isRequired,
	setDoTab: PropTypes.func.isRequired
}

export default compose(
	withState('recentLog', 'setRecentLog'),
	withState('recentExercise', 'setRecentExercise'),
	withState('doTab', 'setDoTab', 'videos')
)(AppLoggedIn)



// WEBPACK FOOTER //
// ./src/AppLoggedIn.js